import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Observable, retryWhen, Subject, Subscription} from 'rxjs';
import {environment} from '@env/environment';
import {WebSocketSubject} from 'rxjs/internal/observable/dom/WebSocketSubject';
import {delay, tap} from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class SocketService implements OnDestroy {
    socketDataSource = new BehaviorSubject<any>(null);
    public socket$: WebSocketSubject<any>;
    isConnected = new Subject<boolean>();
	socketBaseUrl: string = environment.socketBaseUrl;
    sessionId: string;
    private subscription = new Subscription();

	constructor() {
	}

	connectAsync(sessionId: string) {
        this.sessionId = sessionId;
	    this.connect();
	    return new Promise<any>((resolve) => {
	        this.subscription.add(
                this.isConnected.subscribe(val => {
                    console.log('Socket is connected!');
                    // this.isConnected.next(true);
	                resolve(val);
                }, error => {
                    resolve(false);
                })
            );
        });
    }

    createWebSocket(url: string) {
        return new Observable(observer => {
            try {
                this.socket$ = new WebSocketSubject({
                    url,
                    openObserver: {
                        next: value => {
                            this.isConnected.next(true);
                        }
                    }
                });
                const subscription = this.socket$.asObservable()
                    .subscribe(message => {
                            observer.next(message);
                            if (message?.action) {
                                this.socketDataSource.next(message);
                            }
                        }, error => console.log(error),
                        () => observer.complete());

                return () => {
                    if (!subscription.closed) {
                        subscription.unsubscribe();
                    }
                };
            } catch (error) {
                return observer.error(error);
            }
        });
    }

	connect() {
        this.subscription.add(
            this.createWebSocket(`${this.socketBaseUrl}?sessionId=${this.sessionId}`)
                .pipe(retryWhen(errors => errors.pipe(tap(), delay(5000))))
                .subscribe(data => {
                    // this.startHeartbeat();
                }, err => {
                    console.error(err);
                })
        );
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.socketDataSource.complete();
        this.isConnected.complete();
        if (this.socket$) {
            this.socket$.complete();
        }
    }


}
